<template>
<div class="container">
    <div class="flex-box">
        <p class="fwoh-classifi">{{ current_section }} > {{ current_article[0].word }}</p>
        <p class="fwoh-point">{{ current_section_article_point[current_article[0].id-1].point }}P</p>
    </div>
<!------------->
    <div>
    <h2 class="fwoh-title">{{ current_article[0].title }}</h2>
    <h3 class="fwoh-sub">{{ current_article[0].title_sub }}</h3>
    </div>
<!------------->
    <div class="flex-box">
    <img v-if="current_article[0].id < 10" class="fwoh-image" :src="require('../assets/img/article_img/image_article_00'+current_article[0].id+'.png')" />
    <img v-else class="fwoh-image" :src="require('../assets/img/article_img/image_article_0'+current_article[0].id+'.png')" />
    </div>
<!------------->
    <div v-if="session_fwohlist == 'is first article'">
        <div v-for=" (fwohitem, index) in fwohlist" :key="fwohitem.index">
            <button v-if="!fwohitem.isquest" class="fwoh-button">{{ fwohitem.key }}</button>
            <div v-else-if="fwohitem.code != '' ">
                <button class="fwoh-button fwoh-answered" @click="prevcodedel(fwohitem.key,index)">{{ fwohitem.key }}</button>
                <span class="nulldesc">←눌러서 코드 [{{ fwohitem.code }}] 수정</span>
            </div>
            <div v-else>
                <button v-show="fwohitem.code == '' " class="fwoh-button fwoh-nullbtn" @click="codeintput(fwohitem.key,index)">{{ fwohitem.key }}</button>
                <span v-show="fwohitem.code == '' " class="nulldesc">←눌러서 코드 입력</span>
            </div>
            <p class="fwoh-value">{{ fwohitem.value }}</p>
        </div>
    </div>
    <div v-else>
        <div v-for=" (fwohitem, index) in session_fwohlist" :key="fwohitem.index">
            <button v-if="!fwohitem.isquest" class="fwoh-button">{{ fwohitem.key }}</button>
            <div v-else-if="fwohitem.checked==false">
                <button class="fwoh-button fwoh-answered checked-false" @click="prevcodedel(fwohitem.key,index)">{{ fwohitem.key }}</button>
                <span class="nulldesc">←눌러서 코드 [{{ fwohitem.code }}] 수정</span>
            </div>
            <div v-else-if="fwohitem.checked==true">
                <button class="fwoh-button fwoh-answered checked-true" @click="prevcodedel(fwohitem.key,index)">{{ fwohitem.key }}</button>
                <span class="nulldesc">←눌러서 코드 [{{ fwohitem.code }}] 수정</span>
            </div>
            <div v-else-if="fwohitem.checked==null && fwohitem.code">
                <button class="fwoh-button fwoh-answered" @click="prevcodedel(fwohitem.key,index)">{{ fwohitem.key }}</button>
                <span class="nulldesc">←눌러서 코드 [{{ fwohitem.code }}] 수정</span>
            </div>
            <div v-else>
                <button v-show="fwohitem.code == '' " class="fwoh-button fwoh-nullbtn" @click="codeintput(fwohitem.key,index)">{{ fwohitem.key }}</button>
                <span v-show="fwohitem.code == '' " class="nulldesc">←눌러서 코드 입력</span>
            </div>
            <p class="fwoh-value">{{ fwohitem.value }}</p>
        </div>
    </div>
<!------------->
    <router-link to="/game/factcheck" class="fwoh-factcheck-active" @click.native.prevent="updateChecklist">팩트체크</router-link>
    <router-link to='/game/news' @click.native.prevent="cleararticleid" ><div class="fwoh-back-button"></div></router-link>
<!------------->
            <div v-show="showcodeinputmodal && session_fwohlist == 'is first article'" class="codeinput-mask">
                <div class="codeinput-wrapper">
                <div class="codeinput-container">
                <p class="codeinput-header">{{modalkey}}</p>
                <span>코드 : </span><input v-model="modalcode" type="text" />
                <p class="invaildcode" v-show="invaildcode">유효하지 않은 코드입니다.</p>
                <button class="codeinput-button" @click="codeintputtoview">
                입력
                </button>
                 </div>
                </div>
            </div>
            <div v-show="showcodeinputmodal && session_fwohlist != 'is first article'" class="codeinput-mask">
                <div class="codeinput-wrapper">
                <div class="codeinput-container">
                <p class="codeinput-header">{{modalkey}}</p>
                <span>코드 : </span><input v-model="modalcode" type="text" />
                <p class="invaildcode" v-show="invaildcode">유효하지 않은 코드입니다.</p>
                <button class="codeinput-button" @click="codeintputtoview2">
                입력
                </button>
                 </div>
                </div>
            </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
/* eslint-disable */
export default {
    data () {
        return {
            showcodeinputmodal :false,
            modalkey: '',
            modalcode: '',
            modalindex: '',
            invaildcode: false,
        }
    },
    computed:{
        ...mapGetters([
            'session_fwohlist',
            'current_section',
            'current_article',
            'current_section_id',
            'current_cluevalue',
            'fwohlist',
            'current_section_article_point',
            'session_checklist',
        ]),
    },
    methods:{
        codeintput(type,index) {
            this.showcodeinputmodal = !this.showcodeinputmodal
            this.modalkey = type
            this.modalindex = index
            this.modalcode = ''
        },
        prevcodedel(type,index) {
            console.log("prevcodedel in", type, index)
            this.showcodeinputmodal = !this.showcodeinputmodal
            this.modalkey = type
            this.modalindex = index
            console.log("prevcodedel outoutout")
            this.$store.dispatch('prevcodedel', type)
        },
        codeintputtoview() {
            this.fwohlist[this.modalindex].code = this.modalcode
            const payload = { code : this.modalcode, typeloca : this.modalkey}
            if(this.modalcode != ''){
                this.$store.dispatch('sendUserCode', payload)
            }
            else{
                this.showcodeinputmodal = !this.showcodeinputmodal
                this.fwohlist[this.modalindex].value = ''
                this.invaildcode = false
                return
            }
            if(!this.current_cluevalue){
                this.invaildcode = true
            }
            else{
                this.fwohlist[this.modalindex].value = this.current_cluevalue
                this.showcodeinputmodal = !this.showcodeinputmodal
                this.invaildcode = false
            }
        },
        cleararticleid() {
            this.$store.dispatch('loadArticleState', this.current_section_id )
            this.$store.dispatch('loadSectionState')
        },
         updateChecklist() {
            this.$store.dispatch('loadChecklist')
        },
        codeintputtoview2() {
            this.session_fwohlist[this.modalindex].code = this.modalcode
            const payload = { code : this.modalcode, typeloca : this.modalkey}
            if(this.modalcode != ''){
                this.$store.dispatch('sendUserCode', payload)
            }
            else{
                this.showcodeinputmodal = !this.showcodeinputmodal
                this.session_fwohlist[this.modalindex].value = ''
                this.invaildcode = false
                return
            }
            if(!this.current_cluevalue){
                this.invaildcode = true
            }
            else{
                this.session_fwohlist[this.modalindex].value = this.current_cluevalue
                this.showcodeinputmodal = !this.showcodeinputmodal
                this.invaildcode = false
            }
        },
    }
}
</script>

<style>
/* codeinput-modal */
.codeinput-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.codeinput-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.codeinput-container {
  width: 270px;
  margin: 0px auto;
  padding: 20px 30px;
  border: black solid 5px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.codeinput-header{
    border:black 1px solid;
    text-align: center;
    padding: 5%;

}
.codeinput-container input{
    font-size: 1em;
    margin: 1em 0;
    border-radius: 0px;
    width: 77%;
    border: none;
    border-bottom: black 1px solid !important;
}
.codeinput-button {
  display: block;
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1em;
  width: 60%;
  margin: 0 20%;
  border: none;
  padding: 2%;
}
.invaildcode{
    font-size: small;
    margin-bottom: 1em;
    text-align: center;
    color: red;
}
/**************************/
</style>





// WEBPACK FOOTER //
// src/components/5w1h.vue